import { useMutation } from '@tanstack/react-query';

import { uploadFileToS3 } from '@/helpers';
import { useApiMutation, useFetch } from '@/modules/common';

import { CreateMaskBody, MaskUploadUrlData } from '../types';

export function useCreateMask() {
  const fetchClient = useFetch();

  const getUploadUrlDataMutation = useMutation<
    MaskUploadUrlData & { file: File },
    undefined,
    { file: File }
  >({
    mutationFn: async ({ file }) => {
      const res = await fetchClient('/masks/upload-url', {
        method: 'GET',
      });
      return { ...res, file };
    },
    onSuccess: async ({ uploadUrl, file }) => {
      await uploadFileToS3({
        file,
        uploadUrl: uploadUrl,
      });
    },
  });

  const createMaskMutation = useApiMutation<CreateMaskBody>('/masks', {
    method: 'POST',
  });

  const processMaskMutation = useMutation<void, undefined, { maskId: string }>({
    mutationFn: ({ maskId }) => {
      return fetchClient(`/masks/${maskId}/process`, {
        method: 'POST',
      });
    },
  });

  return {
    createMaskMutation,
    getUploadUrlDataMutation,
    processMaskMutation,
  } as const;
}
